import Api from './Api'
import { DeclarationInterface } from 'interfaces'
import { errorHandler } from 'utils'

class Declaration extends Api {
  readonly urls = {
    all: '/Declaration/AllDeclaration',
    allActive: '/Declaration/AllActiveDeclaration',
    save: '/Declaration/Save',
    remove: '/Declaration/Remove/',
  }

  all = async (skip: number = 0, top: number = 10): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.all}?$top=${top}&$skip=${skip * top}&$orderby=id desc`,
      );
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  allActive = async (): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.allActive)
      const data = {
        "items": [],
          "nextPageLink": null,
            "count": 0
      }
      return data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  save = async (data: DeclarationInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.save, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  remove = async (id: number | string): Promise<any> => {
    try {
      const result = await this.postJsonData(`${this.urls.remove}${id}`)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default Declaration
